export class GroupEvent {
    group_event_id: string;
    name: string;
    event_date: string;
    event_type: string;
    event_scoring: string;
    status: string;
    course_id: string;
    tees_id: string;
    registration_start: string;
    registration_end: string;
    group_id: string;
    is_multi_round: string;
    multi_round_id: string;
    is_browsable: string;
    sponsor_count: string;
    player_count: string;
    is_private: string;
    points_system: string;
    nbr_of_holes: string;
    // WI 82: which nine a 9-hole round plays (1 = front 1-9, 10 = back 10-18).
    // Optional: additive column, not set at every GroupEvent construction site.
    starting_hole?: string;
    recurrence_id: string;
    is_ryder_cup: string;
    hide_leaderboard: string;
    event_image_url: string;
    use_hcp: string;
    percent_hcp: string;
    description: string;
    group_eventcol: string;
}


export class GroupEventListItem {
  group_event_id: number;
  group_name: string;
  group_type: number;
  group_id: number;
  event_name: string;
  event_status_id: number;
  event_scoring: string;
  event_scoring_id: number;
  course_name: string;
  course_id: string;
  game_type: string;
  event_type: string;
  event_date: string;
  is_multi_round: number;
  is_admin: number;
  event_status: string;
  tab_name: string;
  is_registered: string;
  total_score: string;
}
